import Link from "next/link";

const Social_Share = ({ detailsPageUrl }) => {

  // Encode URL to handle special characters
  const encodedUrl = encodeURIComponent(detailsPageUrl);

  // Construct share URLs
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
  const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}`;
  const whatsappShareUrl = `https://wa.me/?text=${encodedUrl}`;

  return (
    <div className="share mb-5 lg:mb-[2.5vw]">
      <h3 className="font-secondary text-black uppercase text-[18px] lg:text-[1.3vw] mb-4 lg:mb-[1.5vw]">
        Share :
      </h3>

      <div className="flex flex-wrap gap-5">
        <Link
          href={facebookShareUrl ?? ''}
          className="w-[50px] h-[50px] lg:w-[4vw] lg:h-[4vw] bg-[#F6F6F6] flex rounded-[50%]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 22 23"
            fill="#000"
            className="w-[40%] m-auto"
          >
            <path d="M13.0034 22.8354V12.9354H16.009L16.5 8.53545H13.0034V6.39238C13.0034 5.25938 13.0324 4.13545 14.6156 4.13545H16.2192V0.9896C16.2192 0.9423 14.8417 0.835449 13.4482 0.835449C10.538 0.835449 8.71574 2.65836 8.71574 6.00566V8.53545H5.5V12.9354H8.71574V22.8354H13.0034Z"></path>
          </svg>
        </Link>

        <Link
          href={twitterShareUrl ?? ''}
          className="w-[50px] h-[50px] lg:w-[4vw] lg:h-[4vw] bg-[#F6F6F6] flex rounded-[50%]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 25 22"
            className="w-[40%] m-auto fill-black"
          >
            <path d="M24.5 21.4521H17.2976L10.5144 13.1253L2.03946 21.4521H0L9.61742 12.0244L0 0.21875H7.07373L13.5756 8.14256L21.6591 0.21875H23.6495L14.4739 9.235L24.5 21.4521ZM18.1707 19.9639H21.476L6.45406 1.61343H3.07178L18.1707 19.9639Z"></path>
          </svg>
        </Link>

        <Link
          href={whatsappShareUrl ?? ''}
          className="w-[50px] h-[50px] lg:w-[4vw] lg:h-[4vw] bg-[#F6F6F6] flex rounded-[50%]"
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="#000"
            className="w-[40%] m-auto fill-black"
          >
            <g clipPath="url(#clip0_1284_862)">
              <path
                d="M20.7184 16.0892C20.6639 16.063 18.6226 15.0578 18.2599 14.9273C18.1118 14.8741 17.9532 14.8222 17.7844 14.8222C17.5088 14.8222 17.2772 14.9595 17.0969 15.2294C16.893 15.5324 16.2757 16.254 16.085 16.4695C16.0601 16.498 16.0261 16.532 16.0057 16.532C15.9874 16.532 15.6715 16.4019 15.5759 16.3604C13.3862 15.4092 11.7241 13.1218 11.4962 12.7361C11.4636 12.6806 11.4622 12.6554 11.462 12.6554C11.47 12.6261 11.5436 12.5523 11.5816 12.5142C11.6928 12.4042 11.8132 12.2592 11.9298 12.1189C11.985 12.0524 12.0402 11.9859 12.0945 11.9232C12.2636 11.7264 12.3389 11.5737 12.4262 11.3968L12.4719 11.3049C12.685 10.8815 12.503 10.5243 12.4442 10.4089C12.3959 10.3124 11.534 8.23218 11.4423 8.01363C11.222 7.48627 10.9308 7.24072 10.5262 7.24072C10.4886 7.24072 10.5262 7.24072 10.3687 7.24736C10.177 7.25545 9.13288 7.3929 8.67124 7.6839C8.1817 7.99254 7.35352 8.97636 7.35352 10.7065C7.35352 12.2637 8.3417 13.734 8.76597 14.2932C8.77652 14.3073 8.79588 14.3359 8.82397 14.377C10.4488 16.7499 12.4743 18.5084 14.5277 19.3287C16.5045 20.1184 17.4406 20.2096 17.9728 20.2096H17.9729C18.1965 20.2096 18.3755 20.1921 18.5334 20.1765L18.6336 20.167C19.3165 20.1064 20.8172 19.3288 21.1586 18.3802C21.4275 17.633 21.4984 16.8166 21.3195 16.5204C21.197 16.3189 20.9858 16.2175 20.7184 16.0892Z"
                fill="black"
              />
              <path
                d="M14.2485 0C6.66525 0 0.495797 6.12309 0.495797 13.6494C0.495797 16.0836 1.14725 18.4665 2.38134 20.5519L0.0192516 27.5196C-0.0247484 27.6495 0.00797888 27.7932 0.10407 27.891C0.173433 27.9618 0.267524 28 0.363615 28C0.400433 28 0.437524 27.9945 0.473706 27.9829L7.73916 25.6742C9.72734 26.7365 11.9744 27.2972 14.2486 27.2972C21.8312 27.2973 28 21.1748 28 13.6494C28 6.12309 21.8312 0 14.2485 0ZM14.2485 24.454C12.1086 24.454 10.036 23.8361 8.25434 22.667C8.19443 22.6276 8.12489 22.6075 8.05489 22.6075C8.01789 22.6075 7.9808 22.6131 7.94471 22.6245L4.30516 23.7815L5.48007 20.3152C5.51807 20.203 5.49907 20.0793 5.42907 19.9836C4.07234 18.1298 3.35516 15.9395 3.35516 13.6494C3.35516 7.69091 8.24189 2.84327 14.2484 2.84327C20.2543 2.84327 25.1404 7.69091 25.1404 13.6494C25.1405 19.6071 20.2544 24.454 14.2485 24.454Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_1284_862">
                <rect width="28" height="28" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default Social_Share;
